import { SpacedDash } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';

export const stringifyPrimaryText = (strings: string[]): string => joinStrings(strings, UnicodeEntity.NoBreakSpace);

export const stringifyDateRange = (strings: string[]): string => joinStrings(strings, SpacedDash);

const joinStrings = (strings: string[], separator: string): string => {
    const validStrings = strings.filter((str) => str !== '');
    return validStrings.join(separator);
};
